import React from 'react';
import { Link } from 'react-router-dom';

const HeroPost = props => {
    const { postBy, postDate, categories, title } = props.blogData;

    return (
        <section className="heroPostBox">
            <div className="heroBox">
                <h1 className="headingPrimary globalHeadingPrimary">{title}</h1>
                <br />
                <div className="blogMeta">Posted by <Link to="/about-me">{postBy}</Link> | On {postDate} | <span className="metaCategory">{categories}</span>
                </div>
            </div> {/* Hero Box */}
        </section>
    );
};

export default HeroPost;